import { render, staticRenderFns } from "./NavFooter.vue?vue&type=template&id=4551d4a6&scoped=true&"
import script from "./NavFooter.vue?vue&type=script&lang=js&"
export * from "./NavFooter.vue?vue&type=script&lang=js&"
import style0 from "./NavFooter.vue?vue&type=style&index=0&id=4551d4a6&lang=stylus&scoped=true&"
import style1 from "./NavFooter.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4551d4a6",
  null
  
)

export default component.exports